import { useForm } from "react-hook-form";
import { Parametro } from "../../models/administracion/Parametro";
import { useEffect, useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { useToken } from "../../components/useToken";

export const Parametrizacion = ({ permss, toast, generic, opcion, id }) => {

        const omodel = new Parametro();
        const defaultValues = generic.default(omodel.model, null);
        const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
        const [registers, setRegisters] = useState(null);
        const procesoSrv = new MonitoreoService();
        const { accionesTbl } = Generico();
        const [item, setItem] = useState(null);
        const [dialogConfig, setDialogConfig] = useState(false);
        const [catalogos, setCatalogos] = useState(null);
        const { getRol } = useToken();
        const { table, setLoading, setTotalRecords, lazyParams, inDrop, inArea, inText } =
            InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

        useEffect(() => {
            loadLazyData();
        }, [lazyParams]);

        const loadLazyData = () => {
            setLoading(true);
            let _lazyParams = lazyParams;
            delete _lazyParams.rtipo;
            if (catalogos == null) {
                _lazyParams.rtipo = true;
            }
            _lazyParams.opcion = opcion;
            _lazyParams.idp = id;
            if(getRol()) {
                _lazyParams.rol = getRol();
            }
            procesoSrv.listado('admin-config-sistema/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
                setTotalRecords(res.data.total);
                setRegisters(res.data.registros);
                setLoading(false);
                if (catalogos === null) {
                    setCatalogos(res.data.catalogos);
                }
            });
        }

        const openNew = () => {
            setDialogConfig(true);
            reset(defaultValues);
        }

        const onSubmit = (data) => {
            data.opcion = opcion;
            data.idp = id;
            if(getRol()) {
                data.rol = getRol();
            }
            if (getValues('id') == null) {
                procesoSrv.nuevo(data, 'admin-config-sistema/nuevo').then(res => {
                    generic.funcSuccess(res, toast);
                    setDialogConfig(false);
                    loadLazyData();
                }).catch(error => {
                    generic.funcError(error, toast, setError);
                });
            }
            else {
                procesoSrv.editar(data, 'admin-config-sistema/editar').then(res => {
                    generic.funcSuccess(res, toast);
                    setDialogConfig(false);
                    loadLazyData();
                }).catch(error => {
                    generic.funcError(error, toast, setError);
                });
            }
        }

        const editar = () => {
            procesoSrv.consultar(item?.id, 'admin-config-sistema/consulta').then(res => {
                reset(generic.renewValues(res.data, omodel.model));
                setDialogConfig(true);
            });
        };

        const confirmDelete = () => {
            confirmDialog({
                message: '¿Está seguro de eliminar el registro?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: () => eliminar()
            });
        }

        const eliminar = () => {
            procesoSrv.eliminar(item?.id, 'admin-config-sistema/eliminar').then(res => {
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcDeleteError(error, toast);
            });
        }

        const itemsMenu = () => {
            const items = [];
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
            if (permss?.eliminar)
                items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

            return [{ label: 'Opciones', items: items }];
        }

        return (
            <>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
                    {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
                </Card>

                <Dialog visible={dialogConfig} header={getValues('id') == null ? "Nuevo parámetro" : "Editar parámetro"} modal className="p-fluid modal-ssize" onHide={() => {
                    setDialogConfig(false);
                }}
                    style={{ maxWidth: '500px' }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="formgrid grid">
                            {inText('nombre', {}, 12)}
                            {inArea('valor', 3, 30, 12, { obl: '' })}
                            {inText('nemonico', {}, 12)}
                            {inDrop('tipo', catalogos?.tipo, { lab: omodel.optionLabel }, 6)}
                            {inDrop('solo_admin', generic.sino, { lab: omodel.optionLabel }, 6)}
                        </div>
                        {generic.buttonsForms(setDialogConfig)}
                    </form>
                </Dialog>
            </>
        )
}
